// extracted by mini-css-extract-plugin
export default {"cardWrapper":"mYEqZp","cardImage":"dTQQxl","priceContainer":"qX_UAt"};